import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ScoutingStateContextType {
  isScoutingActive: boolean;
  setScoutingActive: (active: boolean) => void;
}

const ScoutingStateContext = createContext<ScoutingStateContextType | undefined>(undefined);

export const ScoutingStateProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isScoutingActive, setIsScoutingActive] = useState(false);

  return (
    <ScoutingStateContext.Provider value={{ isScoutingActive, setScoutingActive: setIsScoutingActive }}>
      {children}
    </ScoutingStateContext.Provider>
  );
};

export const useScoutingState = () => {
  const context = useContext(ScoutingStateContext);
  if (context === undefined) {
    throw new Error('useScoutingState must be used within a ScoutingStateProvider');
  }
  return context;
};
